import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateBlockUserList = {
  blockUserList: { data: null, loading: false, error: null },
};

export const blockUserList = createAsyncThunk('user/blockUserList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/users/blocked`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerBlockUserList = {
  [blockUserList.pending]: (state) => {
    state.blockUserList.loading = true;
    state.blockUserList.error = null;
  },
  [blockUserList.fulfilled]: (state, action) => {
    state.blockUserList.loading = false;
    state.blockUserList.data = true;
    state.blockUserList.error = null;
  },
  [blockUserList.rejected]: (state, action) => {
    state.blockUserList.loading = false;
    state.blockUserList.error = action.payload;
  },
};
